// extracted by mini-css-extract-plugin
module.exports = {"body":"Body_body__25213","noScrolling":"Body_noScrolling__1I_mv"};